import { render } from "./device-details-network.vue?vue&type=template&id=1ff1c72e&scoped=true&ts=true"
import script from "./device-details-network.ts?vue&type=script&lang=ts"
export * from "./device-details-network.ts?vue&type=script&lang=ts"

import "./device-details-network.scss?vue&type=style&index=0&id=1ff1c72e&scoped=true&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff1c72e"]])

export default __exports__